export default __webpack_public_path__ + "static/media/FAC8.82f54c2e.jpg";